import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidReadingMatrixNoTime } from '../../../../mechanics/rid-reading-matrix-no-time/rid-reading-matrix-no-time';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'app-reading-matrix-no-time-page',
  imports: [RidReadingMatrixNoTime],
  templateUrl: './reading-matrix-no-time-page.html',
})
export class ReadingMatrixNoTimePage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly previousAccuracy = computed(() =>
    this.queryParams()['previous-accuracy'] !== undefined ? parseInt(this.queryParams()['previous-accuracy']) : undefined,
  );
}
